import * as React from 'react'
import intl from 'react-intl-universal'
import FeaturedMediaCards from '../Cards/featuredMediaCards.sfc'
import { FeaturedMediaSelector } from '../Selector/featuredMediaSelector'
import { IFeaturedMediaFormContainerSFC } from './types'

const FeaturedMediaFormContainerSFC = (
  props: IFeaturedMediaFormContainerSFC
): JSX.Element => (
  <div className="bootstrap4">
    <FeaturedMediaSelector onAdd={props.doAdd} canAddKey={props.canAddKey} />
    <small className="text-secondary">
      {intl.get('settings.featuredMedia.basicHelpTxt')}
    </small>
    {props.errorMessage && (
      <p className="text-danger pt-1">{props.errorMessage}</p>
    )}
    <FeaturedMediaCards
      cards={props.cards}
      remove={props.doRemove}
      toggleRequired={props.doToggleRequired}
    />
  </div>
)

export default FeaturedMediaFormContainerSFC
